'use client';

import { useEffect, useState } from 'react';

interface Props {
  onLaunch: () => void;
}

export default function LaunchScreen({ onLaunch }: Props) {
  const launchDate = new Date('2026-01-08T17:05:00+05:30').getTime();

  const [mounted, setMounted] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    setMounted(true);
    setTimeLeft(launchDate - Date.now());

    const timer = setInterval(() => {
      const diff = launchDate - Date.now();

      if (diff <= 0) {
        clearInterval(timer);
        onLaunch();
      } else {
        setTimeLeft(diff);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [launchDate, onLaunch]);

  // Prevent hydration mismatch
  if (!mounted) {
    return (
      <div data-component-id="src/components/common/LaunchScreen.tsx:36:6" data-component-path="src/components/common/LaunchScreen.tsx" data-component-line="36" data-component-end-line="42" data-component-file="LaunchScreen.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20flex%20items-center%20justify-center%20bg-gradient-to-br%20from-primary%20via-secondary%20to-accent%20text-white%22%7D" className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary via-secondary to-accent text-white">
        <img data-component-id="src/components/common/LaunchScreen.tsx:37:8" data-component-path="src/components/common/LaunchScreen.tsx" data-component-line="37" data-component-end-line="41" data-component-file="LaunchScreen.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22src%22%3A%22%2Fassets%2Flogo%2Ficpa-logo.png%22%2C%22alt%22%3A%22ICPA%20Logo%22%2C%22className%22%3A%22w-40%22%7D"
          src="/assets/logo/icpa-logo.png"
          alt="ICPA Logo"
          className="w-40"
        />
      </div>
    );
  }

  const format = (ms: number) => {
    const total = Math.max(ms, 0);
    return {
      d: Math.floor(total / (1000 * 60 * 60 * 24)),
      h: Math.floor((total / (1000 * 60 * 60)) % 24),
      m: Math.floor((total / (1000 * 60)) % 60),
      s: Math.floor((total / 1000) % 60),
    };
  };

  const { d, h, m, s } = format(timeLeft);

  return (
    <div data-component-id="src/components/common/LaunchScreen.tsx:59:4" data-component-path="src/components/common/LaunchScreen.tsx" data-component-line="59" data-component-end-line="101" data-component-file="LaunchScreen.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20flex%20items-center%20justify-center%20bg-gradient-to-br%20from-primary%20via-secondary%20to-accent%20text-white%22%7D" className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary via-secondary to-accent text-white">
      <div data-component-id="src/components/common/LaunchScreen.tsx:60:6" data-component-path="src/components/common/LaunchScreen.tsx" data-component-line="60" data-component-end-line="100" data-component-file="LaunchScreen.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20px-6%22%7D" className="text-center px-6">
        <img data-component-id="src/components/common/LaunchScreen.tsx:61:8" data-component-path="src/components/common/LaunchScreen.tsx" data-component-line="61" data-component-end-line="65" data-component-file="LaunchScreen.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22src%22%3A%22%2Fassets%2Flogo%2Ficpa-logo.png%22%2C%22alt%22%3A%22ICPA%20Logo%22%2C%22className%22%3A%22mx-auto%20mb-8%20w-40%22%7D"
          src="/assets/logo/icpa-logo.png"
          alt="ICPA Logo"
          className="mx-auto mb-8 w-40"
        />

        <h1 data-component-id="src/components/common/LaunchScreen.tsx:67:8" data-component-path="src/components/common/LaunchScreen.tsx" data-component-line="67" data-component-end-line="69" data-component-file="LaunchScreen.tsx" data-component-name="h1" data-component-content="%7B%22elementName%22%3A%22h1%22%2C%22className%22%3A%22font-satoshi%20font-bold%20text-3xl%20mb-4%22%2C%22textContent%22%3A%22We%E2%80%99re%20Launching%20Soon%22%7D" className="font-satoshi font-bold text-3xl mb-4">
          We’re Launching Soon
        </h1>

        <p data-component-id="src/components/common/LaunchScreen.tsx:71:8" data-component-path="src/components/common/LaunchScreen.tsx" data-component-line="71" data-component-end-line="73" data-component-file="LaunchScreen.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%2F90%20mb-8%20max-w-md%20mx-auto%22%2C%22textContent%22%3A%22Building%20India%E2%80%99s%20Circular%20Bio-Polymer%20Ecosystem%22%7D" className="text-white/90 mb-8 max-w-md mx-auto">
          Building India’s Circular Bio-Polymer Ecosystem
        </p>

        <div data-component-id="src/components/common/LaunchScreen.tsx:75:8" data-component-path="src/components/common/LaunchScreen.tsx" data-component-line="75" data-component-end-line="92" data-component-file="LaunchScreen.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20gap-4%20mb-10%22%7D" className="flex justify-center gap-4 mb-10">
          {[
            { label: 'Days', v: d },
            { label: 'Hours', v: h },
            { label: 'Min', v: m },
            { label: 'Sec', v: s },
          ].map((item, i) => (
            <div data-component-id="src/components/common/LaunchScreen.tsx:82:12" data-component-path="src/components/common/LaunchScreen.tsx" data-component-line="82" data-component-end-line="90" data-component-file="LaunchScreen.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-white%2F10%20rounded-xl%20px-4%20py-3%20w-20%22%7D"
              key={i}
              className="bg-white/10 rounded-xl px-4 py-3 w-20"
            >
              <div data-component-id="src/components/common/LaunchScreen.tsx:86:14" data-component-path="src/components/common/LaunchScreen.tsx" data-component-line="86" data-component-end-line="86" data-component-file="LaunchScreen.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-2xl%20font-bold%22%7D" className="text-2xl font-bold">{item.v}</div>
              <div data-component-id="src/components/common/LaunchScreen.tsx:87:14" data-component-path="src/components/common/LaunchScreen.tsx" data-component-line="87" data-component-end-line="89" data-component-file="LaunchScreen.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-xs%20uppercase%20tracking-wide%20text-white%2F80%22%7D" className="text-xs uppercase tracking-wide text-white/80">
                {item.label}
              </div>
            </div>
          ))}
        </div>

        <button data-component-id="src/components/common/LaunchScreen.tsx:94:8" data-component-path="src/components/common/LaunchScreen.tsx" data-component-line="94" data-component-end-line="99" data-component-file="LaunchScreen.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22px-6%20py-3%20bg-white%20text-primary%20font-semibold%20rounded-lg%20hover%3Ascale-105%20transition%22%2C%22textContent%22%3A%22Enter%20Website%22%7D"
          onClick={onLaunch}
          className="px-6 py-3 bg-white text-primary font-semibold rounded-lg hover:scale-105 transition"
        >
          Enter Website
        </button>
      </div>
    </div>
  );
}



